import React from 'react';
import { useParams } from 'react-router-dom';
import eventsData from '../data/events.json';
import { Stack, Typography, IconButton, Box } from '@mui/material';
import { AccessTime, CalendarMonth, Place } from '@mui/icons-material';
import ReactMarkdown from 'react-markdown';

const EventDetails = () => {
    const { id } = useParams();
    const event = eventsData.find(event => event.id === id);

    if (!event) {
        return <div>Event not found</div>;
    }

    const formattedDate = new Date(event.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

    return (
        <Stack maxWidth="md" sx={{ mt: 4, mb: 4, gap: 3, mx: 'auto' }}>
            <Typography variant="h4" component="h1">
                {event.title}
            </Typography>
            <Stack direction="row" spacing={1} alignItems="start">
                <Stack direction="column" spacing={1}>
                    <Stack direction="column" spacing={1} alignItems="start">
                        <Stack direction="row" spacing={1} alignItems="center">
                            <CalendarMonth />
                            <span>{formattedDate}</span>
                        </Stack>
                        <Stack direction="row" spacing={1} alignItems="center">
                        <AccessTime />
                        <span>{event.details.time}</span>
                        </Stack>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <IconButton href={`https://www.google.com/maps/search/?api=1&query=${event.details.location}`} target="_blank" rel="noopener noreferrer" size="small" color="primary" aria-label="View on Google Maps" sx={{ p: 0, m: 0 }}>
                                <Place />
                            </IconButton>
                            <span>{event.details.location}</span>
                        </Stack>
                    </Stack>
                    <Box sx={{ lineHeight: '1.5' }}>
                        <ReactMarkdown>{event.details.description}</ReactMarkdown>
                    </Box>
                </Stack>
                <img
                    src={event.image}
                    alt={event.title}
                    style={{
                        width: '250px',
                        height: 'auto',
                        borderRadius: '8px',
                        float: 'right',
                        marginLeft: '20px',
                        marginBottom: '20px'
                    }}
                />

            </Stack>
        </Stack>
    );
};

export default EventDetails; 